import { StorageCaseEnum, StorageKeysEnum } from '@appTypes/enums/global'
import { IUserModel } from '@appTypes/model/user.model'
import { CourseStorageKeys } from '@pages/CreateTicket/book-ticket/constants'
import StorageManager from '@utils/storage-manager'

export type ClubProfilePayload = {
  user?: {
    id: string
    email: string
    isVerified: boolean
    isActive: boolean
  }
  club?: IUserModel['club']
  member?: unknown
}

export const getAuthStorage = (): StorageCaseEnum => {
  const rememberMe = StorageManager.getString(StorageKeysEnum.REMEMBER_ME)

  return rememberMe === StorageCaseEnum.SESSION
    ? StorageCaseEnum.SESSION
    : StorageCaseEnum.LOCAL
}

export const getStoredAccessToken = (): string | null => {
  const storage = getAuthStorage()

  return StorageManager.getString(StorageKeysEnum.ACCESS_TOKEN, storage)
}

export const getStoredRefreshToken = (): string | null => {
  const storage = getAuthStorage()

  return StorageManager.getString(StorageKeysEnum.REFRESH_TOKEN, storage)
}

export const hasStoredSession = (): boolean => Boolean(getStoredAccessToken())

/** Club portal accounts have a club and are not member-app users. */
export const isClubPortalProfile = (profile: ClubProfilePayload | null | undefined): boolean =>
  Boolean(profile?.user?.id && profile?.club?.id && profile.member == null)

export const getProfileFromResponse = (
  response: { data?: { data?: ClubProfilePayload } } | null | undefined
): ClubProfilePayload | null | undefined => response?.data?.data

export const mapProfileToAuthUser = (profile: ClubProfilePayload): IUserModel | null => {
  if (!isClubPortalProfile(profile) || !profile.user || !profile.club) {
    return null
  }

  return {
    ...profile.user,
    club: profile.club
  }
}

export const persistAuthTokens = (
  accessToken: string,
  refreshToken: string,
  rememberMe: boolean
) => {
  const storage = rememberMe ? StorageCaseEnum.LOCAL : StorageCaseEnum.SESSION

  StorageManager.setString(StorageKeysEnum.REMEMBER_ME, storage, StorageCaseEnum.LOCAL)
  StorageManager.setString(StorageKeysEnum.ACCESS_TOKEN, accessToken, storage)
  StorageManager.setString(StorageKeysEnum.REFRESH_TOKEN, refreshToken, storage)
}

export const clearAuthSession = () => {
  const storage = getAuthStorage()

  StorageManager.removeItem(StorageKeysEnum.ACCESS_TOKEN, storage)
  StorageManager.removeItem(StorageKeysEnum.REFRESH_TOKEN, storage)

  localStorage.removeItem(CourseStorageKeys.ACTIVE_STEP)
  localStorage.removeItem(CourseStorageKeys.COMMENT)
  localStorage.removeItem(CourseStorageKeys.COURSE)
  localStorage.removeItem(CourseStorageKeys.DATE)
  localStorage.removeItem(CourseStorageKeys.GROUPS)
  localStorage.removeItem(CourseStorageKeys.MEMBERS)
}

export const syncTokensToAuthState = () => ({
  accessToken: getStoredAccessToken() || '',
  refreshToken: getStoredRefreshToken() || ''
})
